import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  'title',
  'body',
];

export const resultAttributes = [
  'title',
  'body',
  'latlon',
  'project_status',
  'project_type',
  'url',
  'nid',
  'image_style_uri',
  'image_svg_url',
];

export const facetAttributes: SearchkitWrapperProps['searchSettings']['facet_attributes'] = [
  {
    attribute: 'project_status',
    field: 'project_status',
    type: 'string',
  },
  {
    attribute: 'project_type',
    field: 'project_type',
    type: 'string',
  },
];

export const sorting: SearchkitWrapperProps['searchSettings']['sorting'] = {
  default: {
    field: 'title',
    order: 'asc',
  },
};
